/**
 * Site-wide constants mirroring the backend content module.
 * Kept in sync manually because a bilingual law firm site changes rarely.
 */
export const BUSINESS = {
  name: "Garcia-Windsor, P.C.",
  phoneDisplay: "214-466-6699",
  phoneTel: "+12144666699",
  street: "1015 N Bishop Ave",
  city: "Dallas",
  state: "TX",
  postal: "75208",
  mapUrl: "https://www.google.com/maps/dir/?api=1&destination=1015+N+Bishop+Ave%2C+Dallas%2C+TX+75208",
  hours: "Mon–Fri 9am–5pm",
  taglineEn: "Protecting What Matters Most, Together",
  taglineEs: "Protegiendo lo que más importa, juntos",
  baseUrl: "https://www.garciawindsor.com",
  social: {
    instagram: "https://www.instagram.com/garciawindsorlaw/",
    facebook: "https://www.facebook.com/GarciaWindsor/",
    tiktok: "https://www.tiktok.com/@garciawindsorlaw",
    x: "https://x.com/garciawindsorpc",
    youtube: "https://www.youtube.com/@GarciaWindsorLaw",
    linkedin: "https://www.linkedin.com/company/garcia-windsor-attorneys-&-abogados",
  },
  media: ["CBS", "FOX", "ABC", "Dr. Phil", "Telemundo"],
};

export const SERVICES = [
  { key: "divorce", en_slug: "divorce-laws", es_slug: "divorcio", en_title: "Divorce", es_title: "Divorcio" },
  { key: "contested-divorce", en_slug: "contested-divorce", es_slug: "divorcio-contencioso", en_title: "Contested Divorce", es_title: "Divorcio Contencioso" },
  { key: "high-asset-divorce", en_slug: "high-asset-divorce", es_slug: "divorcio-con-altos-activos", en_title: "High Asset Divorce", es_title: "Divorcio con Altos Activos" },
  { key: "property-assets", en_slug: "property-assets", es_slug: "activos-inmobiliarios", en_title: "Property & Assets", es_title: "Bienes y Propiedades" },
  { key: "domestic-violence", en_slug: "domestic-violence", es_slug: "violencia-domestica", en_title: "Domestic Violence", es_title: "Violencia Doméstica" },
  { key: "restraining-orders", en_slug: "restraining-orders", es_slug: "ordenes-de-restriccion", en_title: "Restraining Orders", es_title: "Órdenes de Restricción" },
  { key: "child-custody", en_slug: "child-custody", es_slug: "custodia-infantil", en_title: "Child Custody", es_title: "Custodia Infantil" },
  { key: "child-support", en_slug: "child-support", es_slug: "manutencion-de-los-hijos", en_title: "Child Support", es_title: "Manutención de los Hijos" },
  { key: "wills-and-trusts", en_slug: "wills-and-trusts-dallas-lawyers", es_slug: "testamentos-y-fideicomisos", en_title: "Wills & Trusts", es_title: "Testamentos y Fideicomisos" },
  { key: "grandparents-stepparent-adoptions", en_slug: "grandparents-stepparent-adoptions", es_slug: "abuelo-padrastro-adoptivo", en_title: "Grandparent / Stepparent Adoption", es_title: "Adopción de Abuelos/Padrastros" },
  { key: "assisted-reproduction", en_slug: "assisted-reproduction", es_slug: "reproduccion-asistida", en_title: "Assisted Reproduction", es_title: "Reproducción Asistida" },
  { key: "common-law-marriages", en_slug: "common-law-marriages", es_slug: "matrimonios-de-hecho", en_title: "Common Law Marriage", es_title: "Matrimonios de Hecho" },
  { key: "same-sex-divorce", en_slug: "same-sex-divorce", es_slug: "divorcio-de-parejas-del-mismo-sexo", en_title: "Same-Sex Divorce", es_title: "Divorcio de Parejas del Mismo Sexo" },
  { key: "legal-separation", en_slug: "legal-separation", es_slug: "separacion-legal", en_title: "Legal Separation", es_title: "Separación Legal" },
  { key: "prenuptial-postnuptial", en_slug: "prenuptial-postnuptial-agreements", es_slug: "acuerdos-prenupciales-y-postnupciales", en_title: "Prenuptial & Postnuptial Agreements", es_title: "Acuerdos Prenupciales y Postnupciales" },
  { key: "alimony", en_slug: "alimony", es_slug: "pension-alimenticia", en_title: "Alimony", es_title: "Pensión Alimenticia" },
];

export const UI = {
  en: {
    languageToggle: "Español",
    otherLangUrl: "/es",
    navHome: "Home",
    navAbout: "About Us",
    navFamilyLaw: "Family Law",
    navBusinessLaw: "Business Law",
    navBlog: "Blog",
    navContact: "Contact Us",
    navTestimonials: "Testimonials",
    navPress: "Press",
    ctaConsultation: "Request a confidential consultation",
    ctaCall: "Call 214-466-6699",
    ctaCallNow: "Call Now",
    ctaLearnMore: "Learn More",
    ctaContact: "Contact Us",
    // [Phase 26] Neutral fallback only — the visible chip is upgraded to the
    // live figure (e.g. "4.3★ on Google (323 reviews)") by useGoogleRating().
    trustGoogle: "Rated on Google",
    trustSuperLawyers: "Super Lawyers",
    trustConsulate: "Mexican Consulate Consulting Attorney",
    trustBilingual: "Se Habla Español",
    asSeenOn: "As Seen On",
    membersOf: "As Members Of",
    quickResponse: "We respond within one business day",
    preferSpanish: "¿Prefiere español? Visite nuestro sitio en español →",
    skipContent: "Skip to content",
    officeAddress: "1015 N Bishop Ave, Dallas, TX 75208",
    officeHoursShort: "Mon–Thu 8:30am–5:30pm · Fri 8:30am–5pm",
    officeHoursFull: "Monday–Thursday: 8:30am–5:30pm\nFriday: 8:30am–5:00pm\nSaturday–Sunday: Closed",
    disclaimer: "Results may vary. Testimonials do not guarantee outcomes.",
    attorneyAd: "This website constitutes attorney advertising. Prior results do not guarantee a similar outcome.",
    footerFamilyLaw: "Family Law Services",
    footerFirm: "The Firm",
    footerConnect: "Connect With Us",
    privacy: "Privacy Policy",
    terms: "Terms of Service",
    familyLawUrl: "/family-law",
    businessLawUrl: "/business-law",
    aboutUrl: "/about-us",
    isabelaUrl: "/about-us/isabela-a-garcia",
    andrewUrl: "/about-us/andrew-jee",
    testimonialsUrl: "/about-us/testimonials",
    pressUrl: "/about-us/press",
    resourcesUrl: "/about-us/our-resources",
    contactUrl: "/contact-us",
    blogUrl: "/blog",
    locationsUrl: "/locations",
    privacyUrl: "/privacy",
    termsUrl: "/terms",
  },
  es: {
    languageToggle: "English",
    otherLangUrl: "/",
    navHome: "Inicio",
    navAbout: "Acerca de Nosotros",
    navFamilyLaw: "Derecho Familiar",
    navBusinessLaw: "Derecho Empresarial",
    navBlog: "Blog",
    navContact: "Contáctenos",
    navTestimonials: "Testimonios",
    navPress: "Prensa",
    ctaConsultation: "Solicitar una consulta confidencial",
    ctaCall: "Llame al 214-466-6699",
    ctaCallNow: "Llamar Ahora",
    ctaLearnMore: "Más Información",
    ctaContact: "Contáctenos",
    // [Phase 26] Respaldo neutral — el chip visible se actualiza a la cifra
    // en vivo (p. ej. "4.3★ en Google (323 reseñas)") mediante useGoogleRating().
    trustGoogle: "Calificado en Google",
    trustSuperLawyers: "Super Abogada",
    trustConsulate: "Abogada Consultora del Consulado de México",
    trustBilingual: "Hablamos su idioma",
    asSeenOn: "Vistos en",
    membersOf: "Miembros de",
    quickResponse: "Respondemos en un día hábil",
    preferSpanish: "Do you prefer English? Visit our English site →",
    skipContent: "Ir al contenido principal",
    officeAddress: "1015 N Bishop Ave, Dallas, TX 75208",
    officeHoursShort: "Lun–Jue 8:30am–5:30pm · Vie 8:30am–5pm",
    officeHoursFull: "Lunes–Jueves: 8:30am–5:30pm\nViernes: 8:30am–5:00pm\nSábado–Domingo: Cerrado",
    disclaimer: "Los resultados pueden variar. Los testimonios no garantizan resultados.",
    attorneyAd: "Este sitio web constituye publicidad de abogados. Los resultados anteriores no garantizan un resultado similar.",
    footerFamilyLaw: "Servicios de Derecho Familiar",
    footerFirm: "El Bufete",
    footerConnect: "Conéctese Con Nosotros",
    privacy: "Política de Privacidad",
    terms: "Términos del Servicio",
    familyLawUrl: "/es/derecho-de-familia",
    businessLawUrl: "/es/derecho-empresarial",
    aboutUrl: "/es/acerca-de-nosotros",
    isabelaUrl: "/es/acerca-de-nosotros/isabela-a-garcia",
    andrewUrl: "/es/acerca-de-nosotros/andrew-jee",
    testimonialsUrl: "/es/acerca-de-nosotros/testimonios",
    pressUrl: "/es/acerca-de-nosotros/prensa",
    resourcesUrl: "/es/acerca-de-nosotros/formularios-y-recursos",
    contactUrl: "/es/contactenos",
    blogUrl: "/es/blog",
    locationsUrl: "/es/ubicaciones",
    privacyUrl: "/es/privacidad",
    termsUrl: "/es/terminos",
  },
};

export function detectLang(pathname) {
  return pathname.startsWith("/es") ? "es" : "en";
}

export function serviceUrl(service, lang) {
  return lang === "es"
    ? `/es/derecho-de-familia/${service.es_slug}`
    : `/family-law/${service.en_slug}`;
}

export function serviceTitle(service, lang) {
  return lang === "es" ? service.es_title : service.en_title;
}

/** GA4 event helper (no-op if gtag is missing). */
export function trackEvent(name, params = {}) {
  try {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: name, ...params });
      if (typeof window.gtag === "function") {
        window.gtag("event", name, params);
      }
    }
  } catch (err) {
    // Non-fatal: analytics must never break the UI. Log for observability.
    if (typeof console !== "undefined" && console.warn) {
      console.warn(`[trackEvent] failed for "${name}":`, err);
    }
  }
}


/**
 * Canonical event names for the site (Phase 18).
 *
 * We want to migrate the codebase to Google's recommended taxonomy while
 * preserving the historical events for GA4 reports that already reference
 * them. Callers should use ``trackAction("click_to_call", params)`` for
 * new code; the helper re-emits the legacy name automatically so
 * pre-existing GA4 explorations keep working.
 */
const EVENT_ALIASES = {
  click_to_call: "phone_click",         // legacy
  language_switch: "es_toggle_click",   // legacy
  // Events without a legacy pair are still safe to route through
  // ``trackAction`` — they just skip the alias firing.
  form_start: null,
  form_submit: null,
  form_error: null,
  email_click: null,
  directions_click: null,
  chat_start: null,
  // ------------------------------------------------------------------
  // [Phase 24, 2026-08-26] Accessibility instrumentation.
  //
  // We do NOT track individual assistive-technology profiles (that
  // would be intrusive and, in some jurisdictions, quasi-medical).
  // We DO track anonymous signals that tell the firm how many
  // visitors LIKELY rely on assistive tech, so we can prioritise
  // the right investments:
  //
  //   * ``a11y_skip_link_shown``: the Skip-to-Main-Content link
  //     received keyboard focus (fires at most once per session).
  //     Strong proxy for "this user is navigating by keyboard."
  //
  //   * ``a11y_skip_link_used``: the user activated the skip link
  //     (click, Enter, Space). Even stronger proxy.
  //
  //   * ``a11y_form_error_announced``: at least one aria-live
  //     ``role="alert"`` error message became visible after a form
  //     submission attempt. Fires once per submission attempt with
  //     the ``fields`` param listing the field names that failed
  //     (never the values). Lets us measure how often screen-reader
  //     announcements actually happen.
  //
  //   * ``a11y_prefers_reduced_motion``: the visitor's OS is set to
  //     ``prefers-reduced-motion: reduce``. Fires once per session
  //     at page-load so we know what fraction of traffic asks us
  //     to dial down animation.
  //
  // All four events are PII-free and use ``session_scope: true``
  // so GA4 reports show unique-visitor counts, not raw firing.
  // ------------------------------------------------------------------
  a11y_skip_link_shown: null,
  a11y_skip_link_used: null,
  a11y_form_error_announced: null,
  a11y_prefers_reduced_motion: null,
  // [Phase 25, 2026-08-27] Fired when a visitor clicks through from the
  // live Google-reviews module on the Testimonials page to the firm's
  // Google Business Profile. PII-free (only rating/count params).
  google_reviews_click: null,
};

/**
 * Fire a canonical GA4 event and, if applicable, also fire the legacy
 * event name so existing GA4 reports/audiences remain valid during the
 * migration. Deduplicated: each name is emitted at most once per call.
 *
 * @param {string} canonical - canonical event name from EVENT_ALIASES
 * @param {object} params    - non-PII event params (do not include email,
 *                             phone number, or raw user text)
 */
export function trackAction(canonical, params = {}) {
  const emitted = new Set();
  const emit = (name) => {
    if (!name || emitted.has(name)) return;
    emitted.add(name);
    trackEvent(name, params);
  };
  emit(canonical);
  const legacy = EVENT_ALIASES[canonical];
  if (legacy) emit(legacy);
}

/**
 * [Phase 24, 2026-08-26] Accessibility event helper.
 *
 * Fires ``a11y_*`` events at most once per browser session so GA4
 * reports show unique-visitor counts rather than raw firing counts.
 * Uses ``sessionStorage`` for dedup — safe on all modern browsers and
 * gracefully degrades when unavailable (private-mode, etc.).
 *
 * Also stamps a stable ``session_scope: true`` param so the GA4
 * exploration can distinguish these anonymous session-level signals
 * from per-interaction events (like ``phone_click``).
 *
 * @param {string} name    - canonical a11y event name (must start with ``a11y_``)
 * @param {object} params  - non-PII event params (field names OK, values NOT)
 */
export function trackA11yEvent(name, params = {}) {
  if (!name || typeof name !== "string" || !name.startsWith("a11y_")) return;
  try {
    const storage = typeof window !== "undefined" && window.sessionStorage;
    if (storage) {
      const key = `gw_a11y_fired_${name}`;
      if (storage.getItem(key)) return;
      try { storage.setItem(key, String(Date.now())); } catch (_) { /* quota */ }
    }
    trackAction(name, { session_scope: true, ...params });
  } catch (_) {
    // Never let analytics break the a11y flow.
  }
}

/**
 * Fire a Google Ads conversion. Reads the account ID + per-action label
 * from ``window.__GW_ANALYTICS__`` (populated by the analytics head
 * snippet, see ``backend/analytics.py``). Silently no-ops if either the
 * account ID or the label is missing so form submits + tel: taps continue
 * to work while credentials are still being wired.
 *
 * Per the 2026-07-27 PPC brief, form submissions ALSO emit a GA4
 * ``generate_lead`` event alongside the Ads conversion so GA4 sees the
 * lead independently of the Ads account. Phone clicks emit the GA4
 * ``phone_click`` event via the ``trackEvent`` caller (not here).
 *
 * @param {"formSubmission"|"phoneClick"} which - which conversion action.
 * @param {object=} params - optional extra params forwarded to gtag.
 */
export function fireAdsConversion(which, params = {}) {
  try {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    var cfg = window.__GW_ANALYTICS__ || {};
    var adsId = cfg.adsId || "";
    var labels = cfg.labels || {};
    var label = labels[which] || "";

    // GA4 side — always fire the ``generate_lead`` event for form
    // submissions, regardless of whether the Ads label is configured.
    // This makes GA4 the durable source of truth for lead-conversion
    // reporting even if the Ads side is misconfigured.
    if (which === "formSubmission") {
      try { window.gtag("event", "generate_lead", params); } catch (e) { /* ignore */ }
    }

    if (!adsId || !label) {
      // Ads side isn't fully configured yet — GA4 event above still fired.
      return;
    }
    window.gtag("event", "conversion", Object.assign({
      send_to: adsId + "/" + label,
    }, params));
  } catch (err) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn(`[fireAdsConversion] failed for "${which}":`, err);
    }
  }
}

/**
 * Fire a Google Ads conversion AND then invoke a follow-up callback when
 * the beacon has been acknowledged by Google (or after a safety timeout).
 *
 * This is the React-friendly equivalent of Google's recommended
 * ``gtag_report_conversion(url)`` snippet:
 *
 * .. code-block:: js
 *
 *     gtag('event', 'conversion', {
 *       send_to: 'AW-16709001723/24osCJmm6NgcEPvDvJ8-',
 *       event_callback: callback,
 *     });
 *
 * We use it from the global ``tel:`` click listener so tapping a phone
 * link on a slow mobile network reliably lands the conversion event
 * BEFORE the OS dialer takes the user away from the page — while still
 * guaranteeing that the dialer eventually opens even if gtag/adblock is
 * misbehaving.
 *
 * Contract:
 * - ``eventCallback`` is invoked at most once.
 * - If ``gtag`` is missing OR the Ads label is not configured, the
 *   callback runs immediately (so the phone still dials).
 * - Otherwise a safety timeout (``timeoutMs``, default 700ms) also
 *   fires the callback, so a slow beacon never strands the user.
 *
 * @param {"formSubmission"|"phoneClick"} which
 * @param {object} params - extra params forwarded to gtag
 * @param {function=} eventCallback - runs after beacon or on timeout
 * @param {number=} timeoutMs - safety fallback delay (default 700)
 */
export function fireAdsConversionWithCallback(which, params = {}, eventCallback, timeoutMs = 700) {
  // Idempotent single-shot wrapper so the callback never runs twice.
  var done = false;
  function runOnce() {
    if (done) return;
    done = true;
    if (typeof eventCallback === "function") {
      try { eventCallback(); } catch (e) { /* non-fatal */ }
    }
  }

  try {
    var noGtag = typeof window === "undefined" || typeof window.gtag !== "function";
    var cfg = (typeof window !== "undefined" && window.__GW_ANALYTICS__) || {};
    var adsId = cfg.adsId || "";
    var labels = cfg.labels || {};
    var label = labels[which] || "";

    // GA4 generate_lead side effect (unchanged from fireAdsConversion).
    if (which === "formSubmission" && !noGtag) {
      try { window.gtag("event", "generate_lead", params); } catch (e) { /* ignore */ }
    }

    if (noGtag || !adsId || !label) {
      // Nothing to wait for — run the follow-up callback synchronously.
      runOnce();
      return;
    }

    // Safety net: even if event_callback never fires (adblocker mid-beacon,
    // network stall, etc.), we still deliver the user to their destination.
    if (typeof setTimeout === "function") {
      setTimeout(runOnce, Math.max(0, timeoutMs));
    }

    window.gtag("event", "conversion", Object.assign({
      send_to: adsId + "/" + label,
      event_callback: runOnce,
    }, params));
  } catch (err) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn(`[fireAdsConversionWithCallback] failed for "${which}":`, err);
    }
    // Never strand the caller even on internal errors.
    runOnce();
  }
}
